<template>
  <div class="app-detection-view">
    <div class="vcpl">
      <div class="cpl-header">
        <h2>送检说明</h2>
      </div>
      <div class="cpl-body">
        <div class="cpl-content">
          <article class="detection-state clear">
            <section class="fl">
              <dl>
                <dt>送检单位核验</dt>
                <dd>送检单位应向检验实验室提交如下资料：</dd>
                <dd>营业执照副本（复印件2份，加盖公章）；</dd>
                <dd>委托检验书（下载固定格式,填写完整后加盖公章,1式3份）；</dd>
                <dd>承诺书（下载固定格式,填写完整后加盖公章,加盖骑缝章)；</dd>
                <dd>企业标准（或有关产品的技术依据、技术规范，如代码编写规范。）；</dd>
                <dd>国外产品要提供国外厂家给国内代理商(国内唯一代理商)的授权委托合同（加盖代理商公章）；</dd>
                <dd>个人情况登记表（下载固定格式,填写完整后加盖公章），提供本公司至少五位研发人员个人情况；</dd>
                <dd>检测服务合同（下载固定格式,填写完整后签名加盖公章，并加盖骑缝章,1式2份。）</dd>
                <dd>产品检测全款，提供加盖公章的汇款凭证复印件或汇款凭证扫描件，并提供单位开票信息 （包括：单位地址、名称、税号、开户行、账号、电话号码）；</dd>
              </dl>
            </section>
            <section class="fr">
              <dl>
                <dt>银行账号：</dt>
                <dd>开户行：建行天津宏达支行</dd>
                <dd>户 名：国家计算机病毒应急处理中心</dd>
                <dd>账 号：12001835200052510600</dd>
                <dd class="tip">注：请用单位账户汇款，且汇款单位须与《委托检验书》中委托单位一致。</dd>
              </dl>
              <dl>
                <dt>送检材料寄送地址及联系方式：</dt>
                <dd>通信地址：天津经济技术开发区第四大街80号天大科技园D3</dd>
                <dd>邮政编码：300457</dd>
                <dd>收件人：计算机病毒防治产品检验实验室</dd>
              </dl>
            </section>
          </article>
        </div>
      </div>
    </div>
    <div class="vcpl">
      <div class="cpl-header">
        <h2>我的送检App</h2>
      </div>
      <div class="cpl-hat">
        <router-link class="theme-btn"
                     :to="{name: 'appSafeDetection'}">申请App检测</router-link>
      </div>
      <div class="cpl-body"
           v-loading="loading">
        <div class="cpl-filter">
          <gt-form :inline="true"
                   :model="queryData"
                   @submit.native.prevent>
            <gt-form-item label="上传时间">
              <gt-date-picker v-model="timeRange"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </gt-date-picker>
              <!-- <gt-date-picker v-model="queryData.submitTime"
                              type="date"
                              placeholder="请选择">
              </gt-date-picker> -->
            </gt-form-item>
            <gt-form-item label="APP名称">
              <gt-input v-model="queryData.appName"
                        placeholder="请输入APP名称"></gt-input>
            </gt-form-item>
            <gt-form-item label="版本号">
              <gt-input v-model="queryData.version"
                        placeholder="请输入版本号"></gt-input>
            </gt-form-item>
            <gt-form-item label="状态">
              <gt-select v-model="queryData.status"
                         clearable
                         placeholder="全部">
                <gt-option v-for="(item, index) in statusList"
                           :key="index"
                           :label="item.label"
                           :value="item.value"></gt-option>
              </gt-select>
            </gt-form-item>
            <gt-form-item>
              <button class="theme-btn"
                      @click="search">查询</button>
            </gt-form-item>
          </gt-form>
        </div>
        <div class="cpl-content">
          <div class="common-table-box theme-table-box">
            <table class="table">
              <thead>
                <tr>
                  <th><span>App名称</span></th>
                  <th><span>版本号</span></th>
                  <th><span>MD5</span></th>
                  <th><span>状态</span></th>
                  <th><span>上传时间</span></th>

                  <th><span>操作</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for='(vm, $index) in renderList'
                    :key='$index'>
                  <td>
                    <span>{{vm.appName}}</span>
                  </td>
                  <td>
                    <span>{{vm.version}}</span>
                  </td>
                  <td><span class="fl">{{vm.md5}}</span><i @click="copyMd5(vm.md5)"
                       class="iconfont iconfuzhi copy-md5"></i></td>
                  <td>
                    <span>{{getStatus(vm.status)}}</span>
                  </td>
                  <td>{{$moment(vm.submitTime).format("YYYY-MM-DD HH:mm")}}</td>
                  <td class="table-operate-cell">
                    <a class="operation-btn"
                       v-if="vm.status === 5 && vm.reportId"
                       download
                       :href="generateUrl(vm.reportId)"
                       target="_blank">检测报告</a>
                    <a v-if="vm.contractId"
                       class="operation-btn"
                       download
                       :href="generateUrl(vm.contractId)"
                       target="_blank">合同</a>
                    <router-link class="operation-btn"
                                 :to="{name: 'appDetectionDetail', params: {appId: vm.appId}}">详情</router-link>
                  </td>
                </tr>
                <tr v-if='!renderList.length && !loading'>
                  <td colspan="10"
                      class="no-data">
                    <h3>暂无数据</h3>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="pagination-wrap"
                 v-if='renderList.length'>
              <gt-pagination @current-change="pageChange"
                             background
                             :current-page="queryParams.currentPage"
                             layout="prev, pager, next, jumper"
                             :page-count="totalPage">
              </gt-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { queryList } from '@/api/personal/app_detection'
const sourceData = {
  appName: '',
  version: '',
  status: '',
  startTime: '',
  endTime: '',
  currentPage: 1,
  pageSize: 10
}
/*
  queryData存储绑定的数据以及分页的原配置
  queryParams用于请求
  分页相关的挂载到queryParams
  请求前将queryData 赋值于queryParams
*/
export default {
  name: 'AppDetection',
  data () {
    return {
      queryData: {
        ...sourceData
      },
      queryParams: {
        ...sourceData
      },
      statusList: [{
        label: '全部',
        value: ''
      }, {
        label: '已提交',
        value: 0
      }, {
        label: '受理',
        value: 1
      }, {
        label: '检测中',
        value: 2
      }, {
        label: '补正',
        value: 3
      }, {
        label: '检测不通过',
        value: 4
      }, {
        label: '检测通过',
        value: 5
      }, {
        label: '失效',
        value: 6
      }],
      renderList: [],
      totalPage: 1,
      loading: false,
      timeRange: []
    }
  },
  computed: {
    token () {
      return this.$store.getters.getToken
    }
  },
  methods: {
    generateUrl (id) {
      return `/apiService/virus/app/resource/download?id=${id}&token=${this.token}`
      // return `/apiService/virus/sdk/certification/download?id=${id}&token=${this.token}`
    },
    getStatus (status) {
      // if (status === 7) return ''
      let result = this.statusList.filter(el => {
        return el.value === status
      })
      if (result.length) return result[0].label
    },
    _QueryList (params = { ...sourceData }) {
      if (this.loading) return false
      this.loading = true
      if (this.timeRange && this.timeRange.length > 0) {
        params.startTime = this.$moment(this.timeRange[0]).valueOf()
        params.endTime = this.$moment(this.timeRange[1]).valueOf()
      }
      delete params.timeRange
      queryList(params).then(res => {
        this.loading = false
        const resData = res.data.data
        this.renderList = resData.list
        this.totalPage = Math.ceil(resData.total / this.queryData.pageSize)
      }, errRes => {
        this.loading = false
      })
    },
    search () {
      this.queryParams = { ...this.queryData, currentPage: 1, pageSize: this.queryData.pageSize }
      this._QueryList(this.queryParams)
    },
    pageChange (num) {
      this.queryParams.currentPage = num
      this._QueryList(this.queryParams)
    },
    copyMd5 (md5) {
      let clipboard = new Clipboard('.copy-md5', {
        text: function () {
          return md5
        }
      })
      clipboard.on('success', e => {
        this.$message.info('md5已复制到剪贴板')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        this.$message.error('复制失败，请手动进行复制')
        clipboard.destroy()
      })
    }
  },
  created () {
    this.search()
  }
}
</script>

<style lang='less' scoped>
@pcsl-gap: 20px;
.vcpl {
  // padding: 0 20px 20px 20px;
  position: relative; // background: @base-bgColor;

  .cpl-header {
    position: relative;
    padding-top: 34px;
    padding-bottom: 10px;
    font-size: 14px;
    text-align: left;
    line-height: 1;
    border-bottom: 2px solid #1f9b42;

    h2 {
      color: #333333;
      display: inline-block;
      line-height: 1;
      font-weight: bold;
      text-align: left;
      font-size: 18px;
    }
  }
  .cpl-body {
    .detection-state {
      .fl {
        width: 60%;
        dl {
          padding-right: 36px;

          border-right: 1px dashed #979797;
        }
      }
      .fr {
        padding-left: 26px;
        width: 40%;
      }
      dl {
        dt {
          margin: 10px 0 4px 0;

          font-size: 16px;
          color: #333333;
        }
        dd {
          font-size: 14px;
          color: #666666;
          line-height: 25px;
        }
        .tip {
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }
}
.gt-form {
  padding: 20px 0 0 0;
}
.theme-table-box {
  padding: 10px 10px 20px 10px;
  border: 1px solid #dddddd;
  .table {
    margin-bottom: 20px;
    thead {
      tr {
        th {
          height: 36px;
          color: #333333;
          background: #eeeeee;
        }
      }
    }
    tbody {
      tr {
        background: none;
        td:not(.no-data) {
          height: 40px;
          padding: 0;
          line-height: 40px;
          vertical-align: middle;
          border-bottom: 1px dashed @table-borderColor;
          p {
            // margin-bottom: 6px;
            font-size: 12px;
            color: #666666;
            line-height: 20px;
          }
          .copy-md5 {
            float: left;
            font-size: 14px;
            margin-left: 8px;
            color: #337ab7;
            cursor: pointer;
          }
        }
      }
    }
  }
  .table-operate-cell {
    // width: 140px !important;
    width: auto;
    .operation-btn {
      color: #337ab7;
      text-decoration: none;
      &:after {
        content: '';
        opacity: 0;
      }
    }
  }
}
</style>
